// extracted by mini-css-extract-plugin
export default {"bgImage":"SwiperCard_bgImage__B3db+","container":"SwiperCard_container__ur6RX"};